// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
const babel = require("@babel/core");
babel.transform("code", {});
import '@babel/polyfill'

//import './polyfill'

import Vue from 'vue'
import Vuex from 'vuex'
import BootstrapVue from 'bootstrap-vue'
import App from './App.vue'
import router from './router/index.js'
import vuetify from '@/plugins/vuetify'

import i18n from '@/plugins/i18n.js';

import { CarouselCard, CarouselCardItem } from 'vue-carousel-card'
import 'vue-carousel-card/styles/index.css'

Vue.use(CarouselCard, CarouselCardItem);

import store from '@/store';

//Vue.use(Vuex)

/*
 * BEGIN OF CUSTOM DDO CODE
 */
//import vueCookies from 'vue-cookies';

/*
 * Attach config to each Vue. For that :
 * - import vue-config. This allows to have 'this.$config'
 * - import both DVLT and PROD config (both files MUST exist)
 * - depending on process.env.NODE_ENV, use first or seconc config
 * - tell to Vue to use the config JSON array
 */
import vueConfig from 'vue-config';
import configFO from '../config/frontoffice.json';
import configDVLT from '../config/default.json';
import configPROD from '../config/production.json';

var host = window.location.href.split('/');
if ( host.length>=3 ) { host = host[2]; } else { host = host[0]; }

if ( process.env.NODE_ENV === 'production' ) {
   var config = configPROD;
   config.isProd = true;
} else {
   var config = configDVLT;
   config.isProd = false;
}

/*
 * Depending on 'host', and depending on templates in 'configFO.brands'
 * we build a brand : 'ddo', 'smtp-pro', ...
 */
config.host = host;
if ( configFO.brands ) {
   for ( var i=0;i<configFO.brands.length;i++ ) {
      if ( host.match(new RegExp(configFO.brands[i].url)) ) {
         config.values = configFO.brands[i].values;
         break;
      }
   }
}
Vue.use(vueConfig,config);

Vue.prototype.$config = config;

import VueAnalytics from 'vue-analytics';
Vue.use(VueAnalytics, {
   id: config.analytics.gtagid,
   router
});

import apiPlugin from '@/plugins/api'
Vue.use(apiPlugin,{config: config})

//import refreshNav from '@/plugins/refresh_nav.js';
//console.log('AFTER IMPORT refresh_nav');

/* 
 * END OF CUSTOM DDO CODE
 */

Vue.use(BootstrapVue)

/* eslint-disable no-new */
new Vue({
   el: '#app',
   router,
   store,
   vuetify,
   i18n,
   template: '<App/>',
   components: {
      App
   },
   created: async function () {
      let session = sessionStorage.getItem('session')
      if ( session!==null ) {
         const { errorinfos, api_response } = await this.$api.getRow(this.$router,'session',session);
         if ( api_response.error==0 && api_response.row.ses_is_valid==true ) {
            //refreshNav.methods.refreshNav(api_response.row.ses_sessionfields,api_response.row.platform_list);
         } else {
            session = null
         }
      }
   },
   mounted: function () {
   },
   updated: function () {
   }
})
